import { ResourceState } from '@domain/schemas/contract.schema';

export const getFormattedStatus = (status: string) => {
  if (status === 'FIRM_ORDER') {
    return 'Firm Order';
  }

  if (status === ResourceState.PRE_DRAFT) {
    return 'Pre-Draft';
  }

  const firstChar = status[0];
  const restChars = status.slice(1);

  return `${firstChar}${restChars.toLowerCase()}`;
};
